import _ from "lodash";

export {
    showDateTime
}

const showDateTime = (createdAt) => {
    if (_.isObject(createdAt)) {
        // @ts-ignore
        return new Date(createdAt.seconds * 1000).toLocaleString();
    }

    return '';
}
